import { useEffect, useRef, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import ConciergeriePage from "@/pages/ConciergeriePage";
import CityPage from "@/pages/CityPage";
import ReglementationPage from "@/pages/ReglementationPage";
import ContactPage from "@/pages/ContactPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";

// Components
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <div className="App noise-bg min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/conciergerie" element={<ConciergeriePage />} />
            <Route path="/conciergerie/:citySlug" element={<CityPage />} />
            <Route path="/reglementation-airbnb" element={<ReglementationPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
